import {useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import {getCities,updateCity,getALlCityAndCategory,addnewCityCategory, DeleteCity} from './CityRepo'
import { toast } from "react-toastify";
import { showToast } from "../../../../utils/toastUtils";

type ReqBody = {
      Itownid: number;
      LocationAutoComplete_Itownid: string;
      Category: string;
      GradeId: number;
    };

interface AddCityRequest {
      Itownid: number;
      LocationAutoComplete_Itownid: string;
      Category: string;
      GradeId: number;
}


//fetch all the cities
export const useGETCities = ({ enable = false, params={} }:{params?:Record<string, any>;enable:boolean})=>{
return useQuery({
      queryKey:["GET_CITIES",params],
      queryFn:()=>getCities(params),
      enabled:enable,
      retry:false
   })
} 


// fetch all  city with category 
export const  useAllCityAndCategory =({enable = false}:{enable?:boolean})=>{
      return useQuery({
            queryKey:['GET_ALLCITY_AND_CATEGORY'],
            queryFn:getALlCityAndCategory,
            enabled:enable,
            retry:false,
      })
}


export const useAddCityCategory =()=>{
      const queryClient = useQueryClient();

      return useMutation({
            // mutationFn: ({ Reqbody }: { Reqbody: AddCityRequest }) => addnewCityCategory({ Reqbody }),
            mutationFn: ({ Reqbody }: { Reqbody: AddCityRequest }) =>{
                  
                if(!Reqbody || !Reqbody.Category || !Reqbody.Itownid){
                  return  Promise.reject(new Error('Invalid reqbody'));
                }  
               return addnewCityCategory({ Reqbody })
            },

            onSuccess:()=>{
                  showToast.success('Added successfully!')
                 queryClient.invalidateQueries({queryKey:['GET_CITIES',]})  
            },
            onError:(error:any)=>{
                  console.error('Failed To Add City:', error.message);
                  showToast.error("Failed to add city. Please try again.");
            },
            retry:false

      })
}


export const UpdateCities=()=>{
      const queryClient = useQueryClient();
      return useMutation({
      mutationFn: ({ id, Reqbody }: { id: number; Reqbody: ReqBody }) => updateCity({ id, Reqbody }),
      onSuccess:()=>{
            showToast.success('update successfully!')
             queryClient.invalidateQueries({queryKey:['GET_CITIES',]}) 
         },
      onError:(error:any)=>{
                  console.error("Failed to update:", error.message)    
                  showToast.error("Failed to update city. Please try again.");  
      }
      })
} 

export const useDeleteCity = ()=>{
      const queryClient = useQueryClient();
      return useMutation({
            mutationFn:(id:number)=>DeleteCity(id),
            onSuccess:()=>{
            showToast.success('City Deleted Successfully')
            queryClient.invalidateQueries({queryKey:['GET_CITIES']})
            },
            onError:(error:any)=>{
                  console.log('Failed to delete city:',error.message);
                  showToast.error('Failed to delete city. Please try again.');
            }
      })
}